module.exports = __webpack_public_path__ + "img/archived_rates.d09daff1.jpg";